import { useState, useCallback } from 'react';

const MESI = ['Gennaio','Febbraio','Marzo','Aprile','Maggio','Giugno','Luglio','Agosto','Settembre','Ottobre','Novembre','Dicembre'];

const pillBase = {
  padding: '10px 18px', borderRadius: 20, fontSize: 13, fontWeight: 500,
  border: '0.5px solid rgb(var(--border))', cursor: 'pointer',
  transition: 'all 0.15s', lineHeight: 1,
};
const arrowBtn = {
  padding: '10px 14px', minWidth: 44, minHeight: 44, fontSize: 16, fontWeight: 400,
  border: '0.5px solid rgb(var(--border))', borderRadius: 8,
  background: 'rgb(var(--bg))', color: 'rgb(var(--text))',
  cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
  transition: 'all 0.15s', lineHeight: 1,
};
const labelStyle = {
  fontSize: 14, fontWeight: 500, color: 'rgb(var(--text))',
  minWidth: 140, textAlign: 'center', userSelect: 'none',
};

function isFuturo(modalita, sel) {
  const now = new Date();
  const anno = now.getFullYear(), mese = now.getMonth() + 1;
  const trim = Math.ceil(mese / 3);
  if (modalita === 'mese') return sel.anno > anno || (sel.anno === anno && sel.mese > mese);
  if (modalita === 'trimestre') return sel.anno > anno || (sel.anno === anno && sel.trimestre > trim);
  return sel.anno > anno;
}

function getLabel(modalita, sel) {
  if (modalita === 'mese') return `${MESI[sel.mese - 1]} ${sel.anno}`;
  if (modalita === 'trimestre') return `Q${sel.trimestre} ${sel.anno}`;
  return `${sel.anno}`;
}

function naviga(modalita, sel, dir) {
  const next = { ...sel };
  if (modalita === 'mese') {
    next.mese += dir;
    if (next.mese > 12) { next.mese = 1; next.anno++; }
    if (next.mese < 1)  { next.mese = 12; next.anno--; }
    next.trimestre = Math.ceil(next.mese / 3);
  } else if (modalita === 'trimestre') {
    next.trimestre += dir;
    if (next.trimestre > 4) { next.trimestre = 1; next.anno++; }
    if (next.trimestre < 1) { next.trimestre = 4; next.anno--; }
    next.mese = (next.trimestre - 1) * 3 + 1;
  } else {
    next.anno += dir;
  }
  return next;
}

export function buildPeriodoParams(modalita, sel) {
  if (modalita === 'mese')
    return { periodo: 'mese', mese: sel.mese, anno: sel.anno };
  if (modalita === 'trimestre')
    return { periodo: 'trimestre', trimestre: sel.trimestre, anno: sel.anno };
  return { periodo: 'anno', anno: sel.anno };
}

export default function SelectorePeriodo({ onChange }) {
  const now = new Date();
  const [modalita, setModalita] = useState('mese');
  const [sel, setSel] = useState({
    anno: now.getFullYear(),
    mese: now.getMonth() + 1,
    trimestre: Math.ceil((now.getMonth() + 1) / 3),
  });

  const emitChange = useCallback((mod, s) => {
    if (onChange) onChange(buildPeriodoParams(mod, s));
  }, [onChange]);

  const cambiaModalita = (mod) => {
    setModalita(mod);
    emitChange(mod, sel);
  };

  const nav = (dir) => {
    const next = naviga(modalita, sel, dir);
    if (dir > 0 && isFuturo(modalita, next)) return;
    setSel(next);
    emitChange(modalita, next);
  };

  const disabledAvanti = isFuturo(modalita, naviga(modalita, sel, 1));

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
      {/* Pill modalita */}
      <div style={{ display: 'flex', gap: 4 }}>
        {[
          { key: 'mese', label: 'Mese' },
          { key: 'trimestre', label: 'Trimestre' },
          { key: 'anno', label: 'Anno' },
        ].map(p => (
          <button
            key={p.key}
            onClick={() => cambiaModalita(p.key)}
            style={{
              ...pillBase,
              background: modalita === p.key ? 'var(--brand)' : 'rgb(var(--bg))',
              color: modalita === p.key ? '#fff' : 'rgb(var(--muted))',
              border: modalita === p.key ? '0.5px solid var(--brand)' : '0.5px solid rgb(var(--border))',
            }}
          >
            {p.label}
          </button>
        ))}
      </div>

      {/* Navigazione */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
        <button onClick={() => nav(-1)} style={arrowBtn} aria-label="Periodo precedente">
          &#8249;
        </button>
        <div style={labelStyle}>{getLabel(modalita, sel)}</div>
        <button
          onClick={() => nav(1)}
          disabled={disabledAvanti}
          style={{
            ...arrowBtn,
            opacity: disabledAvanti ? 0.35 : 1,
            cursor: disabledAvanti ? 'not-allowed' : 'pointer',
          }}
          aria-label="Periodo successivo"
        >
          &#8250;
        </button>
      </div>
    </div>
  );
}
